import styled from 'styled-components';
import media from '../../../../styles/media.style';

export const Wrapper = styled.div`
  position: relative;
  width: 300px;
  margin: 0 auto 32px;
  ${media.tabletL`
    margin: 0 auto 40px;
  `};
`;

export const Steps = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
export const Step = styled.div`
  width: 40px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  background: #ccc;
  border-radius: 50%;
  font-size: 20px;
  &.active {
    background: #999;
  }
`;

export const Line = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  width: 100%;
  border-top: dotted 3px #bbb;
`;

export const Progress = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  border-top: dotted 3px #999;
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/DiagnosisStep/DiagnosisStep.style.js